import { render, staticRenderFns } from "./AxUserRegisterDialog.vue?vue&type=template&id=8cc85db2&scoped=true"
import script from "./AxUserRegisterDialog.vue?vue&type=script&lang=ts"
export * from "./AxUserRegisterDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxUserRegisterDialog.vue?vue&type=style&index=0&id=8cc85db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc85db2",
  null
  
)

export default component.exports